import {
	ComponentProps,
	forwardRef,
	Ref,
	RefObject,
	useLayoutEffect,
} from 'react'

import { cn } from '@/utils'

import { inputCls } from './Input'
import { fieldErrorCls, fieldLabelCls } from './InputField'

export interface TextareaProps
	extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
	label?: string
	error?: string | boolean
}

export const TextAreaInput = forwardRef(
	(
		{
			label,
			error,
			className,
			...props
		}: ComponentProps<'textarea'> & TextareaProps,
		ref: Ref<HTMLTextAreaElement>,
	) => {
		const resolvedId =
			props.id ||
			(typeof label === 'string'
				? label.toLowerCase().replace(/\s+/g, '-')
				: undefined)

		return (
			<>
				{label ? (
					<label htmlFor={resolvedId} className={fieldLabelCls}>
						{label}
					</label>
				) : null}
				<textarea
					ref={ref}
					{...props}
					id={resolvedId}
					className={cn(
						inputCls(!!error),
						cn('h-24 py-3', label ? 'mt-2' : null),
						className,
					)}
				/>
				{error && <p className={fieldErrorCls}>{error}</p>}
			</>
		)
	},
)
TextAreaInput.displayName = 'TextAreaInput'

export const useResizeTextAreaInput = (
	textAreaRef: RefObject<HTMLTextAreaElement | null>,
	value: string,
	defaultTextAreaHeight: string,
) => {
	useLayoutEffect(() => {
		const el = textAreaRef.current
		if (!el) return

		el.style.height = defaultTextAreaHeight
		el.style.height = el.scrollHeight + 'px'
	}, [textAreaRef, value, defaultTextAreaHeight])
}
